"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = exports.IR_SWAP_INSTRUMENT_TYPE = void 0;
const default_session_1 = require("../../../../session/default-session");
const financial_contracts_1 = require("../financial-contracts");
const table_builder_1 = require("../table-builder");
exports.IR_SWAP_INSTRUMENT_TYPE = 'Swap';
function Definition(params) {
    const { outputs, fields, extendedParams, pricingParameters } = params, instrumentDefinition = __rest(params, ["outputs", "fields", "extendedParams", "pricingParameters"]);
    const definition = {
        instrumentType: exports.IR_SWAP_INSTRUMENT_TYPE,
        instrumentDefinition,
        pricingParameters,
    };
    const tableBuilder = new table_builder_1.TableBuilderImp();
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const financialContracts = new financial_contracts_1.FinancialContractsProvider(session, tableBuilder);
            return financialContracts.getInstrumentAnalytics([definition], { outputs, fields, extendedParams });
        },
        /** @internal */
        getInstrument() {
            return definition;
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9maW5hbmNpYWwtY29udHJhY3RzL2lyLXN3YXAvZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUNBLHlFQUFpRTtBQUNqRSxnRUFBb0U7QUFDcEUsb0RBQW1EO0FBRXRDLFFBQUEsdUJBQXVCLEdBQUcsTUFBTSxDQUFDO0FBRTlDLFNBQWdCLFVBQVUsQ0FDdEIsTUFBNEM7SUFFNUMsTUFBTSxFQUFFLE9BQU8sRUFBRSxNQUFNLEVBQUUsY0FBYyxFQUFFLGlCQUFpQixLQUE4QixNQUFNLEVBQS9CLG9CQUFvQixVQUFLLE1BQU0sRUFBeEYsNERBQStFLENBQVMsQ0FBQztJQUMvRixNQUFNLFVBQVUsR0FBRztRQUNmLGNBQWMsRUFBRSwrQkFBdUI7UUFDdkMsb0JBQW9CO1FBQ3BCLGlCQUFpQjtLQUNwQixDQUFDO0lBQ0YsTUFBTSxZQUFZLEdBQUcsSUFBSSwrQkFBZSxFQUFFLENBQUM7SUFFM0MsT0FBTztRQUNILE9BQU8sQ0FBQyxVQUFtQixJQUFBLDRCQUFVLEdBQUU7WUFDbkMsTUFBTSxrQkFBa0IsR0FBRyxJQUFJLGdEQUEwQixDQUFDLE9BQU8sRUFBRSxZQUFZLENBQUMsQ0FBQztZQUVqRixPQUFPLGtCQUFrQixDQUFDLHNCQUFzQixDQUFDLENBQUMsVUFBVSxDQUFDLEVBQUUsRUFBRSxPQUFPLEVBQUUsTUFBTSxFQUFFLGNBQWMsRUFBRSxDQUFDLENBQUM7UUFDeEcsQ0FBQztRQUNELGdCQUFnQjtRQUNoQixhQUFhO1lBQ1QsT0FBTyxVQUFVLENBQUM7UUFDdEIsQ0FBQztLQUNKLENBQUM7QUFDTixDQUFDO0FBdEJELGdDQXNCQyJ9